import { useEffect, useState } from "react";

import dayjs from "@/lib/helpers/dayjs";
import { getScheduleForToday } from "@/utils/scheduleUtils";

/**
 * Fetches today's schedule and returns calls that are active (call_status === true)
 * with timestamps converted to local HH:mm format.
 * @returns {{ calls: Array|null, nextCall: Object|null }}
 */
export function useProviderSchedule() {
  const [calls, setCalls] = useState(null);
  const [nextCall, setNextCall] = useState(null);

  useEffect(() => {
    getScheduleForToday()
      .then((response) => {
        if (!response?.schedule?.length) return;

        const filteredCalls = response.schedule
          .filter(
            (call) =>
              dayjs.utc(call.timestamp, "YYYY/M/D HH:mm").isSame(dayjs(), "day") &&
              Object.hasOwn(call, "call_status") &&
              call.call_status === true,
          )
          // spread to avoid mutating the original response object
          .map((call) => ({
            ...call,
            timestamp: dayjs.utc(call.timestamp, "YYYY/M/D HH:mm").local().format("HH:mm"),
          }));

        if (filteredCalls.length > 0) {
          setNextCall(filteredCalls[0]);
          setCalls(filteredCalls);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch today's schedule:", err);
      });
  }, []);

  return { calls, nextCall };
}
